export const SIDEBAR_DIMENSIONS = {
  /** Main sidebar width when expanded (px) */
  MAIN_EXPANDED_PX: 256,
  /** Main sidebar width when collapsed (px) */
  MAIN_COLLAPSED_PX: 72,
  /** Main sidebar width when expanded (CSS string) */
  MAIN_EXPANDED_WIDTH: "256px",
  /** Main sidebar width when collapsed (CSS string) */
  MAIN_COLLAPSED_WIDTH: "72px",
  /** Top bar height (px) */
  TOP_BAR_HEIGHT_PX: 64,
  /** Top bar height (CSS string) */
  TOP_BAR_HEIGHT: "64px",
  /** Logo section height */
  LOGO_SECTION_HEIGHT: "64px",
  /** Logo width when sidebar collapsed: the coral mark alone, 30px tall */
  LOGO_COLLAPSED_WIDTH: "30px",
  /** Logo width when sidebar expanded */
  LOGO_EXPANDED_WIDTH: "198px",
  /** Logo margin left when collapsed */
  LOGO_COLLAPSED_MARGIN_LEFT: "8px",
} as const;

export const ANIMATION_DURATION = 300;

/**
 * Z-index values for layering UI components.
 */
export const Z_INDEX = {
  DROPDOWN_MENU: 15,
  TOPBAR: 20,
  SIDEBAR_MAIN: 30,
  TOOLTIP: 50,
  DIALOG: 50,
  MODAL: 50,
  OVERLAY: 50,
  COPILOT_DRAWER: 1000, // Above everything (topbar is 20, sidebar is 30)
} as const;

export const ANIMATION_EASING = "cubic-bezier(0.4, 0, 0.2, 1)";

export const TRANSITIONS = {
  SIDEBAR: `300ms ${ANIMATION_EASING}`,
  BACKGROUND: "background-color 150ms ease",
  PADDING: `padding-top 300ms ${ANIMATION_EASING}`,
} as const;

export const TOOLTIP_STYLES = {
  tooltip: {
    sx: {
      backgroundColor: "#111827f2",
      color: "#d1d5dbe6",
      fontSize: "14px",
      padding: "10px 12px",
      borderRadius: "6px",
      border: "1px solid rgba(55,65,81,.5)",
      boxShadow: "0 10px 15px -3px #0000001a",
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      maxWidth: "280px",
    },
  },
} as const;

/**
 * 2026 HG brand colors. The topbar's chrome (switcher, divider, bottom rule,
 * avatar) is prussian; the logo's wordmark is navy and its mark coral.
 */
export const BRAND_COLORS = {
  CORAL: "#FF4A4A",
  NAVY: "#00023D",
  PRUSSIAN: "#071834",
} as const;
